/**
 * What 3 Ingredients - Portion Scaler Utility
 * Scales ingredient quantities dynamically based on selected target servings (1 to 8).
 * Formats decimal numbers into clean culinary fractions (e.g., 1 ½ tbsp, ¾ tsp).
 */

/**
 * Multiplies quantity by ratio of targetServings / baseServings
 * @param {number} baseQty 
 * @param {number} baseServings 
 * @param {number} targetServings 
 * @returns {string} Formatted quantity string
 */
export function scaleQuantity(baseQty, baseServings = 2, targetServings = 2) {
  if (baseQty == null || isNaN(baseQty)) return '';
  
  const scaled = (baseQty / baseServings) * targetServings;
  return formatFraction(scaled);
}

/**
 * Formats a decimal number into user-friendly fraction
 * @param {number} num 
 * @returns {string}
 */
export function formatFraction(num) {
  if (num <= 0) return '0';
  
  const whole = Math.floor(num);
  const remainder = num - whole;
  
  let fractionStr = '';
  
  // Approximate standard culinary fractions
  if (remainder >= 0.875) {
    return String(whole + 1);
  } else if (remainder >= 0.7) {
    fractionStr = '¾';
  } else if (remainder >= 0.6) {
    fractionStr = '⅔';
  } else if (remainder >= 0.45) {
    fractionStr = '½';
  } else if (remainder >= 0.3) {
    fractionStr = '⅓';
  } else if (remainder >= 0.2) {
    fractionStr = '¼';
  } else if (remainder >= 0.1) {
    fractionStr = '⅛';
  }
  
  if (whole === 0) {
    return fractionStr || (Math.round(num * 10) / 10).toString();
  }
  
  return fractionStr ? `${whole} ${fractionStr}` : String(whole);
}
